import styled, { css } from 'styled-components'
import { BaseWidgetProps } from './types'
import { borderRadius, color, padding, shadow } from '@evrekadev/evreka-ui-components'

export const BaseWidgetStyled = styled.div<BaseWidgetProps & { isDragging?: boolean }>`
  ${borderRadius(12)}
  ${padding([24])}
  ${shadow('xs')}
  /* ${({ size }) => size === '2x2' && padding({ b: 16 })} */

  position: relative;
  overflow: hidden;

  user-select: none;
  height: 100%;

  background-color: ${color('grey25')};
  border: 1px solid ${({ alert }) => color(alert ? 'red100' : 'grey200')};

  ${({ alert }) =>
    alert &&
    css`
      background-color: ${color('red25')};
      opacity: 0.5;
    `}

  grid-column: ${({ size }) => {
    switch (size) {
      case '1x1':
        return 'span 1'
      case '1x2':
      case '2x2':
        return 'span 2'
    }
  }};

  grid-row: ${({ size }) => {
    switch (size) {
      case '1x1':
      case '1x2':
        return 'span 1'
      case '2x2':
        return 'span 2'
    }
  }};

  /* cursor: grab; */

  ${({ isDragging }) =>
    isDragging &&
    css`
      cursor: grabbing;
      opacity: 0.5;
    `}
`
